import { HopperProvider, type HopperProviderProps } from "@hopper-ui/components";
import { getDefaultLocale } from "@sg-protect/core";
import { useCookies, usePrefersColorScheme } from "@sg-protect/components";

const COOKIE_COLOR_SCHEME_PREFERENCE_KEY = "SG-ColorSchemePreference";

function usePersistedColorScheme() {
    const [cookie] = useCookies(COOKIE_COLOR_SCHEME_PREFERENCE_KEY);
    const colorScheme = cookie === "light" || cookie === "dark" ? cookie : "system";

    return [colorScheme] as const;
}

export function AutomaticThemeProvider({ children, ...rest }: Omit<HopperProviderProps, "theme" | "colorScheme">) {
    const [persistedColorScheme] = usePersistedColorScheme();
    const systemColorScheme = usePrefersColorScheme();
    const colorScheme = persistedColorScheme === "system" ? systemColorScheme : persistedColorScheme;

    return (
        <HopperProvider theme="sharegate" locale={getDefaultLocale()} colorScheme={colorScheme} withBodyStyle {...rest}>
            {children}
        </HopperProvider>
    );
}
